angular.module('zc.projects')

.directive 'zcCookieEditor', (ProjectCookie, Meta, BaseProjectCrudEditor) ->

  class CookieEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.pageTypes = {}

  editor = new CookieEditor(
    ProjectCookie
    Meta
    '/templates/projects.settings/initialization/cookie_editor.html'
  )

  return editor.createDirective({domainLinkType: '='})



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/cookie_editor.directive.coffee